import { forwardRef } from "react";
import { DateValue } from "~/shared/lib/analytics-utils";
import { useReportFilterParams } from "../model/use-report-filters";
import { ReportTableHandle } from "./report-table";
import { ReportTabId, reportTab } from "./report-tabs";

interface Props {
  activeReportTab: ReportTabId;
  startDate: DateValue;
  endDate: DateValue;
}

export const AnalyticsReports = forwardRef<ReportTableHandle, Props>(
  ({ activeReportTab, startDate, endDate }, ref) => {
    const { Component, filters } = reportTab(activeReportTab);
    const { filterInfo } = useReportFilterParams(filters);

    return (
      <div className="h-full rounded-xl">
        <div className="content-table h-full">
          <Component ref={ref} startDate={startDate} endDate={endDate} filterInfo={filterInfo} />
        </div>
      </div>
    );
  },
);
